<template>
  <v-card flat tile @click="_click" color="transparent">
    <v-img
      v-bind:src="imagesrc"
      :aspect-ratio="1 / 1"
      width="80%"
      class="mx-auto"
    ></v-img>
    <v-card-text style="font-size:12px" class="px-0 text-center app-title-color font-weight-bold">
      {{ title }}
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      required: false,
    },
    bgColor: {
      type: String,
      required: false,
    },
    imagesrc: {
      type: String,
      required: false,
    },
    imageWidth: {
      type: String,
      required: false,
    },
    xpath:{
      type: String,
      required: true
    }
  },
  data: () => ({
    //
  }),

  methods: {
    _click(){
      console.log(this.path)
      this.$router.push({
        name: "IProductDetailView",
        params: { xpath: this.xpath, title: 'ddfsdfsfd' },
      });
    },
    _getName(k) {
      return "Khangal-" + k;
    },
    _getBgColor() {
      if (this.bgColor != undefined && this.bgColor != null) {
        return this.bgColor;
      } else return "#bbb";
    },
  },
};
</script>
<style scoped>
</style>